import { h } from 'preact'
import { AppRoute } from '../route'
import { AppStore } from '../../store'
import { getStringOrThrow, RouteParam } from '../../../lib/simple-routing/params'
import { ConnectedHeader } from '../../components/Header/Header'
import { AppFrame } from '../../components/frames/AppFrame/AppFrame'
import { Mandatfordeling } from '../../components/moduler/Mandatfordeling/Mandatfordeling'
import { goToKommuneresultater } from '../../store/actions'
import { toMandatTableItem } from '../../components/shared/mandater'
import { ConnectedNabosider } from '../../components/navigasjon/Nabosider/Nabosider'
import { ConnectedUndersider } from '../../components/navigasjon/Undersider/Undersider'
import { selectGeografi } from '../../store/selectors/grunndata'
import { Oppslutning } from '../../components/moduler/Oppslutning/Oppslutning'
import { toOppslutningTableItem } from '../../components/moduler/Oppslutning/mapping'
import { Mandatkamp } from '../../components/moduler/Mandatkamp/Mandatkamp'
import { ConnectedPrimarHeading } from '../../components/headings/PrimarHeading/PrimarHeading'
import { ConnectedSekundarHeading } from '../../components/headings/SekundarHeading/SekundarHeading'
import { BeholderDeFlertallet } from '../../components/moduler/BeholderDeFlertallet/BeholderDeFlertallet'
import { HasMandater } from '../../components/shared/HasMandater/HasMandater'
import { ResultatContainer } from '../../components/resultater/Resultat/Resultat'
import { isGeografi, PartiResultatMedMandat } from '../../domain'
import { ConnectedSammenslaingsInfo } from '../../components/moduler/Info/Sammenslaing'
import { VissteDuAtInfo } from '../../components/moduler/Info/VissteDuAt/VissteDuAt'
import { Pastander } from '../../components/moduler/Pastander/Pastander'
import { ConnectedSperret } from '../../components/moduler/advarsler/Sperret/Sperret'
import { IkkeOpptalt } from '../../components/moduler/advarsler/IkkeOpptalt/IkkeOpptalt'
import { ConnectedBydelsvalgInfo } from '../../components/moduler/Info/BydelsvalgInfo'
import { HasOppslutning } from '../../components/shared/HasOppslutning/HasOppslutning'
import {
  ConnectedFylkesvalgIKommuneInfo,
  FylkesvalgIKommuneInfo
} from '../../components/moduler/Info/FylkesvalgIKommuneInfo/FylkesvalgIKommuneInfo'
import { Skille } from '../../components/shared/Decoration'

export const kommuneRoute: AppRoute = {
  path: `/valg/2019/resultat/:locale/sted/:id([0-9]{4})/:navn?`,
  widget: false,
  title(store: AppStore) {
    const geo = store.getState().page.current
    if (isGeografi(geo)) {
      return { id: 'sidetittel-sted', values: { navn: geo.navn } }
    }
  },
  onRouteChanged: async (store: AppStore, params: RouteParam[]) => {
    const paramId = getStringOrThrow(params, 'id')
    const geo = selectGeografi(store.getState(), paramId)
    return store.dispatch(goToKommuneresultater(geo))
  },
  render: () => {
    return (
      <AppFrame>
        <ConnectedHeader />
        <main>
          <ConnectedPrimarHeading type="kommune" />
          <ConnectedSammenslaingsInfo />
          <ConnectedSperret type="kommune" />
          <ResultatContainer type="kommune">
            {(kommuneresultat, geografi, locale) => {
              const {
                partier = [],
                mandater,
                stemmer,
                flertall,
                opptalt,
                pastander,
                frammote
              } = kommuneresultat
              return (
                <div>
                  {(!opptalt || opptalt.forelopig === 0) && <IkkeOpptalt />}
                  <Oppslutning
                    items={toOppslutningTableItem(partier, locale)}
                    grunndata={geografi}
                    valgtype="kommune"
                  />
                  <Mandatfordeling
                    antall={mandater ? mandater.antall : 0}
                    items={toMandatTableItem(partier, mandater)}
                    geografi={geografi}
                    valgtype="kommune"
                  />
                  <HasMandater partier={partier} antall={mandater && mandater.antall}>
                    <BeholderDeFlertallet
                      mandater={mandater}
                      geografi={geografi}
                      partier={partier as PartiResultatMedMandat[]}
                      flertall={flertall}
                    />
                    <Mandatkamp
                      geografi={geografi}
                      valgtype="kommune"
                      partier={partier}
                      mandater={mandater}
                      stemmer={stemmer}
                      opptalt={opptalt}
                      frammote={frammote}
                    />
                  </HasMandater>
                  <HasOppslutning partier={partier}>
                    <Pastander grunndata={geografi} partier={partier} pastander={pastander} />
                  </HasOppslutning>
                  <VissteDuAtInfo
                    geografi={geografi}
                    resultat={kommuneresultat}
                    valgtype="kommune"
                  />
                </div>
              )
            }}
          </ResultatContainer>
          <ConnectedUndersider />
          <ConnectedNabosider />
          <ConnectedBydelsvalgInfo />
          <Skille />
          <ConnectedSekundarHeading type="fylke" />
          <ConnectedSperret type="fylke" />
          <ResultatContainer type="fylke">
            {(fylkeresultat, geografi, locale) => {
              const { partier, opptalt } = fylkeresultat
              return (
                <div>
                  {(!opptalt || opptalt.forelopig === 0) && <IkkeOpptalt />}
                  <ConnectedFylkesvalgIKommuneInfo />
                  <Oppslutning
                    items={toOppslutningTableItem(partier, locale)}
                    grunndata={geografi}
                    valgtype="fylke"
                  />
                </div>
              )
            }}
          </ResultatContainer>
        </main>
      </AppFrame>
    )
  }
}
